var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg33(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2130_3336)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z",
    fill: "#111111",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 -10C58.482 -10 73.0213 -1.69129 81.6642 10.9645C81.8808 11.2818 81.7786 11.7149 81.446 11.907L52.3226 28.7216C52.1163 28.8407 51.8622 28.8407 51.6559 28.7216L47.3193 26.2178C37.7535 20.6949 25.5209 23.9722 19.998 33.5381C17.3588 38.1098 16.7306 43.2903 17.8371 48.0564C17.9049 48.3483 17.7784 48.6525 17.5189 48.8024L6.82617 54.9766C6.23596 55.3178 6.47823 56.2207 7.16016 56.2207H21.534C21.7338 56.2207 21.9225 56.3107 22.0516 56.4631C23.501 58.1754 25.2649 59.6723 27.3193 60.8584L43.2236 70.041C52.1933 75.2195 62.3835 76.3597 71.6962 74.0328C72.3928 73.8588 72.8896 74.7433 72.3335 75.1974C64.0655 81.9487 53.5067 86 42 86C15.4903 86 -6 64.5097 -6 38C-6 11.4903 15.4903 -10 42 -10Z",
    fill: "#111111",
    fillOpacity: 0.6
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0.5C36.9787 0.5 47.5 11.0213 47.5 24C47.5 36.9787 36.9787 47.5 24 47.5C11.0213 47.5 0.5 36.9787 0.5 24C0.5 11.0213 11.0213 0.5 24 0.5Z",
    stroke: "#111111",
    strokeOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2130_3336"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg33);
export default __webpack_public_path__ + "static/media/3_3.ead21cc2096ccd73ef9df86a16a3e1bd.svg";
export { ForwardRef as ReactComponent };